import styled from "styled-components";

export const SettingsContainer = styled.div`
  width: 280px;
  border-left: 1px solid ${({ theme }) => theme.border.black10};
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
  flex-shrink: 0;
  background-color: ${({ theme }) =>
    theme.name === "dark" ? "#131313" : "#fff"};

  &::-webkit-scrollbar {
    width: 7px;
    display: none;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.border.black15};
    border: 3px solid
      ${({ theme }) => (theme.name === "dark" ? "#131313" : "#fff")};
    border-left: none;

    &:hover {
      background: ${({ theme }) => theme.border.black50};
    }
  }
`;

export const SettingsOptionContainer = styled.div`
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.border.black10};
  }
`;

export const SettingsOptionActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SettingsOptionActionButton = styled.button`
  background: none;
  outline: none;
  border: none;
`;

export const SettingsOptionBackContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.border.black15};
`;

export const SettingsOptionBackButton = styled.button`
  background: transparent;
  border: none;
  display: grid;
  place-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const SettingsOptionBackHeading = styled.h1`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  font-family: "PP Formula";
`;

export const SettingsOptionCollapsibleContainer = styled.details`
  padding-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.border.black15};
  display: flex;
  flex-direction: column;

  &[open] > {
    gap: 8px;

    summary::after {
      transform: rotate(0deg);
    }
  }

  & > div:not(:first-child) {
    margin-top: 8px;
  }
`;

export const SettingsOptionCollapsibleHeading = styled.summary`
  position: relative;
  font-size: 14px;
  color: ${({ theme }) => theme.text.title};
  font-weight: 400;
  list-style: none;

  &::after {
    content: "";
    position: absolute;
    background-image: url("/img/drawers/settings-icons/caret-up.svg");
    height: 20px;
    width: 20px;
    right: 0;
    transform: rotate(180deg);
    cursor: pointer;
  }

  &::-webkit-details-marker {
    display: none;
  }
`;

export const SettingsOptionHeadingInline = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SettingsOptionHeading = styled.h1`
  margin: 0;
  font-size: 12px;
  font-family: "PP Formula";
  color: ${({ theme }) => theme.text.title};
  font-weight: 400;
`;

export const SettingsOptionHeadingLight = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.text.text};
  font-family: "PP Formula";
  font-size: 12px;
  font-weight: 300;
  opacity: 0.65;
`;

export const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: ${({ alignItems = "center" }) => alignItems};

  ${({ direction }) => {
    if (direction === "column") {
      return "flex-direction: column; row-gap: 5px; align-items: flex-start;";
    }
  }}
`;

export const OptionLabel = styled.span`
  font-size: 12px;
  line-height: 1.1;
  margin: ${({ alignToTop }) => (alignToTop ? "10px 0 auto" : 0)};
`;

export const OptionContent = styled.div`
  width: 170px;
  flex-shrink: 0;

  ${({ full }) => full && "width: 100%;"}
`;

export const OptionMessageContainer = styled.div`
  display: flex;
  gap: 4px;
  color: #00afff;
`;

export const OptionMessageParagraph = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
`;

export const OptionInput = styled.input.attrs({ type: "number" })`
  display: flex;
  width: -webkit-fill-available;
  height: 24px;
  padding: 4px 8px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.bg.primary};
  color: ${({ theme }) => theme.text.input};
  font-size: 12px;
  line-height: 12px;
  border: none;
`;

export const TextEditorContainer = styled.div`
  & > div {
    background: ${({ theme }) => theme.bg.primary};
    border-color: ${({ theme }) => theme.bg.primary};

    .text-options-wrapper {
      padding-left: 10px;
      background: transparent;

      & > span {
        display: none;
      }
    }

    .icon-container svg {
      color: ${({ theme }) => theme.border.black50};
    }

    svg.border {
      display: none;
    }
  }
`;
